export default "__VITE_ASSET__NqbtB7LZ__"